import { System_instance3dr57gee6r420 as System_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_DefaultClock() {
  _init_properties_DefaultClock_kt__nc7o19();
  return DefaultClock;
}
var DefaultClock;
function get_default(_this__u8e3s4) {
  _init_properties_DefaultClock_kt__nc7o19();
  return get_DefaultClock();
}
var properties_initialized_DefaultClock_kt_kemfgx;
function _init_properties_DefaultClock_kt__nc7o19() {
  if (!properties_initialized_DefaultClock_kt_kemfgx) {
    properties_initialized_DefaultClock_kt_kemfgx = true;
    DefaultClock = System_instance;
  }
}
//region block: exports
export {
  get_default as get_default1l68fybpthpme,
};
//endregion

//# sourceMappingURL=DefaultClock.mjs.map
